import { timeFormat } from '@/utils'
import operate from './operate'

export default function () {
  return [
    {
      title: '发起组织名称',
      [$field]: 'launchOrgName',
      searchKey: 'launchOrgName'
    },
    {
      title: '征集意见来源',
      [$field]: 'opinionSource',
      searchKey: 'opinionSource',
      showType: 'select'
    },
    {
      title: '征求对象类型',
      [$field]: 'publishScope',
      searchKey: 'publishScope',
      showType: 'select',
      optionList: [
        {
          label: '向组织征集',
          value: '1'
        },
        {
          label: '向个人征集',
          value: '2'
        }
      ],
      render: (h, { row }) => {
        return h('span', row.publishScope == '1' ? '向组织征集' : '向个人征集')
      }
    },
    {
      title: '征集意见标题',
      [$field]: 'title',
      searchKey: 'title'
    },
    {
      title: '征集意见开始时间',
      [$field]: 'startDate',
      searchKey: 'startDate',
      showType: 'datePicker',
      config: {
        searchKeyMap: ['startDateStart', 'startDateEnd']
      },
      props: {
        type: 'daterange'
      },
      render: (h, {row, index}) => h('span', timeFormat(row.startDate, 'yyyy-MM-dd'))
    },
    {
      title: '征集意见结束时间',
      [$field]: 'endDate',
      searchKey: 'endDate',
      showType: 'datePicker',
      config: {
        searchKeyMap: ['endDateStart', 'endDateEnd']
      },
      props: {
        type: 'daterange'
      },
      render: (h, {row, index}) => h('span', timeFormat(row.endDate, 'yyyy-MM-dd'))
    },
    {
      title: '征求意见状态',
      [$field]: 'publishState',
      searchKey: 'publishState',
      showType: 'select',
      optionList: [
        {
          label: '草稿',
          value: 'draft'
        },
        {
          label: '进行中',
          value: 'ing'
        },
        {
          label: '已完成',
          value: 'finish'
        },
        {
          label: '终止',
          value: 'end'
        }
      ],
      render: (h, {row, index}) => {
        let state = {
          'draft': '草稿',
          'ing': '进行中',
          'finish': '已完成',
          'end': '终止'
        }
        let color = {
          'draft': '#b5b5b5',
          'ing': '#ffbd00',
          'finish': '#ff0000',
          'end': '#03da03'
        }
        return h('span', {
          style: {
            color: color[row.publishState]
          }
        }, [
          h('i', {
            class: 'status-point',
            style: {
              backgroundColor: color[row.publishState]
            }
          }), state[row.publishState]]
        )
      }
    },
    {
      title: '意见填写状态',
      [$field]: 'feedbackState',
      searchKey: 'feedbackState',
      showType: 'select',
      optionList: [
        {
          label: '未反馈',
          value: 0
        },
        {
          label: '已反馈',
          value: 1
        }
      ],
      render: (h, {row, index}) => {
        let feedbackState = {
          0: '未反馈',
          1: '已反馈'
        }
        return h('span', feedbackState[row.feedbackState])
      }
    },
    {
      title: '操作',
      [$field]: 'operate',
      isOperate: true,
      slotComponent: operate
    }
  ]
}
